(function(Manogi, $, undefined) {
    
    //Private

    //Public
    

   
    Manogi.validateRegister = function() {
        $.oc.stripeLoadIndicator.show();
        var $form = $('#register-form');
        $form.request('account::onRegister', {
            data: {
                
            },
            success: function(response) {
                if(response.failed){
                    $.oc.stripeLoadIndicator.hide();
                    $.each(response.errors, function(name,message){
                        $('*[name="'+name+'"]').addClass('u-error');
                        var $message = $('*[name="'+name+'"]').closest('.js-container').find('.js-message');
                        $message.addClass('u-error').text(message);
                        if(name == 'password'){
                            $('*[name="password_confirmation"]').addClass('u-error');
                            $('*[name="password_confirmation"]').closest('.js-container').find('.js-message').addClass('u-error').text(message);
                        }
                    });
                }
                else{
                    window.location.reload();
                }
            }
        });
    };

    Manogi.validateNewsletterForm = function() {
        $.oc.stripeLoadIndicator.show();
        var $form = $('#newsletter-form');
        var $form_message = $('#newsletter-form-message');
        $form.request('customPage::onRegisterNewsletter', {
            data: {
                
            },
            success: function(response) {
                if(response.failed){
                    $.oc.stripeLoadIndicator.hide();
                    $.each(response.errors, function(name,message){
                        $('*[name="'+name+'"], *[name="'+name+'[]"]').addClass('u-error');
                        var $message = $('*[name="'+name+'"], *[name="'+name+'[]"]').closest('.js-container').find('.js-message');
                        $message.addClass('u-error').text(message);
                    });
                }
                else{
                  $.oc.stripeLoadIndicator.hide();
                  $form.hide();
                  $form_message.removeClass('hide');
                }
            }
        });
    };

    Manogi.validateAccount = function() {
        $.oc.stripeLoadIndicator.show();
        var $form = $('#account-form');
        $form.request('account::onChangeAccount', {
            data: {
                
            },
            success: function(response) {
                if(response.failed){
                    $.oc.stripeLoadIndicator.hide();
                    $.each(response.errors, function(name,message){
                        $('*[name="'+name+'"]').addClass('u-error');
                        var $message = $('*[name="'+name+'"]').closest('.js-container').find('.js-message');
                        $message.addClass('u-error').text(message);
                        if(name == 'password'){
                            $('*[name="password_confirmation"]').addClass('u-error');
                            $('*[name="password_confirmation"]').closest('.js-container').find('.js-message').addClass('u-error').text(message);
                        }
                    });
                }
                else{
                    window.location.reload();
                }
            }
        });
    };

    Manogi.openRegisterModal = function() {
        $.oc.stripeLoadIndicator.show();
        $.ajax({
            url: '/ajax/content/register',
            dataType: 'html',
            success: function(response){
                $.oc.stripeLoadIndicator.hide();

                Manogi.openModal({
                    form : response,
                    show_confirm : true,
                    show_cancel : true,
                    confirm_text : Manogi.translate('register'),
                    cancel_text : Manogi.translate('cancel'),
                    confirm_action : function() { Manogi.validateRegister(); },
                });
            }
        });
    };

    Manogi.openAccountModal = function(token) {
        $.oc.stripeLoadIndicator.show();
        $.ajax({
            data: { token: token },
            url: '/ajax/content/account',
            dataType: 'html',
            success: function(response){
                $.oc.stripeLoadIndicator.hide();

                Manogi.openModal({
                    form : response,
                    show_confirm : true,
                    show_cancel : true,
                    confirm_text : Manogi.translate('save'),
                    cancel_text : Manogi.translate('cancel'),
                    confirm_action : function() { Manogi.validateAccount(); },
                });
            }
        });
    };
    


}( window.Manogi = window.Manogi || {}, jQuery ));